import { DEVELOPMENT_TYPE } from '@/utils/constants/construction-status'
import { DEVELOPMENT, SALE, USED } from '@/utils/constants/filters'

const developmentTypeMixin = {
  data () {
    return {
      developmentType: [],
      values: [],
    }
  },

  methods: {
    $_set_selected_construction (developmentTypesMap) {
      if (!this.selectedConstruction) {
        this.values = []
        return
      }

      const split = this.selectedConstruction.split(',')
      const newArray = []

      split.forEach((el) => {
        const { constructionStatus } = developmentTypesMap.get(el)
        newArray.push(constructionStatus)
      })

      this.values = this.arrayWithNoRepetsValues(newArray)
    },

    $_set_development_type () {
      const map = new Map()
      DEVELOPMENT_TYPE.forEach((item) => {
        map.set(item.constructionStatus, item)
      })

      return map
    },

    $_no_one_construction_selected () {
      const defaultConstruction = {
        business: SALE,
        listingType: USED,
        constructionStatus: '',
      }

      this.values = []
      this.$_filters_update(defaultConstruction)
    },

    arrayWithNoRepetsValues (array = []) {
      const map = new Map()
      map.set('cleanArray', array)
      return map.get('cleanArray')
    },

    onChange () {
      const defaultConstruction = {
        business: SALE,
        listingType: DEVELOPMENT,
        constructionStatus: undefined,
      }

      if (!this.values.length) {
        this.$_no_one_construction_selected()
        return
      }

      this.values.forEach((development) => {
        const { constructionStatus } = this.developmentType.get(development)
        const currentConstruction = defaultConstruction.constructionStatus?.length ? defaultConstruction.constructionStatus.split(',') : []

        const CSClean = this.arrayWithNoRepetsValues([...currentConstruction, constructionStatus])

        defaultConstruction.constructionStatus = CSClean.toString()
      })

      this.$_filters_update(defaultConstruction)
    },

    $_filters_update (filter) {
      this.$emit('filters:update', filter)
    },

  },
}

export default developmentTypeMixin
